import useWebSocket, { ReadyState } from 'react-use-websocket'

import config from '@/config'
import UnlockOfferMessageModal from '@/features/offers/components/Modal/UnlockOfferMessageModal'
import { authSelector } from '@/stores/auth/authSlice'
import { setWorkingOfferViewingUsers } from '@/stores/offers/offersSlice'
import { showModal } from '@/stores/ui/modalSlice'
import { MODAL_TYPES } from '@/utils/constants/modalTypes'
import { isNullish } from '@/utils/helper'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setEditingUserId } from '@/features/offers/slices/offerDetail.slice'

const OfferWebSocketProvider = ({ offerId, children }) => {
  const { user } = useSelector(authSelector)
  const [showUnlockOfferMessageModal, setShowUnlockOfferMessageModal] = useState(false)

  const dispatch = useDispatch()

  const { sendJsonMessage, readyState, lastJsonMessage } = useWebSocket(config.wsURL, {
    onOpen: (event) => {
      // console.log('[Offer] WebSocket connection is established.')
    },
    share: true,
    filter: (messageEvent) => {
      const message = JSON.parse(messageEvent?.data || '')
      return message.type === 'OFFER_USER_UPDATED'
    },
    retryOnError: true,
    shouldReconnect: () => true,
    onMessage: (event) => {
      // console.log(event)
    },
    onError: (event) => {
      console.error('WebSocket error', event)
    },
  })

  useEffect(() => {
    if (user?._id && offerId && readyState === ReadyState.OPEN) {
      // console.log(
      //   `[Offer] User ${user?.fullName || '-'} (${user?._id}) entering offer ${offerId}, sending message to web socket `
      // )
      sendJsonMessage({
        userId: user?._id,
        userName: user?.fullName,
        offerId: offerId,
        type: 'USER_ENTER_OFFER',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, offerId, readyState, sendJsonMessage])

  useEffect(() => {
    if (isNullish(lastJsonMessage)) {
      // console.error('Unexpected Error, missing lastJsonMessage', lastJsonMessage)
      return
    }
    const { offerId: messageOfferId, viewingUsers, editingUserId, editingUserName, popupType } = lastJsonMessage

    // console.log('messageOfferId', messageOfferId)
    // console.log('viewingUsers', viewingUsers)
    if (messageOfferId !== offerId || !viewingUsers || !Array.isArray(viewingUsers)) {
      console.error('Unexpected Error in web socket provider ')
      return
    }

    // console.log('lastJsonMessage', lastJsonMessage)
    dispatch(setWorkingOfferViewingUsers(viewingUsers))
    dispatch(setEditingUserId(editingUserId))

    //Only show lock message when this is the first message user received

    if (popupType === 'LOCK') {
      dispatch(
        showModal({
          modalType: MODAL_TYPES.MESSAGE,
          modalProps: {
            title: 'Offer Locked ! ',
            message: `${editingUserName} is editing the offer right now. You can only view the offer before he/she finish editing. `,
          },
        })
      )
    } else if (popupType === 'UNLOCK') {
      setShowUnlockOfferMessageModal(true)
    }
  }, [lastJsonMessage, offerId, dispatch, user._id])
  return (
    <>
      <UnlockOfferMessageModal
        show={showUnlockOfferMessageModal}
        onClose={() => setShowUnlockOfferMessageModal(false)}
      />
      {children}
    </>
  )
}

export default OfferWebSocketProvider
